{"browser":true,"env":{"ENVIRONMENT":"BROWSER"}}